// Turns a YouTube, Vimeo or Dailymotion link into its embedded player URL and, when the provider offers one
// without an API call, a thumbnail URL.
const PROVIDERS = [
  {
    name: "YouTube",
    pattern: /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([\w-]{11})/,
    embed: (id) => `https://www.youtube.com/embed/${id}`,
    thumbnail: (id) => `https://img.youtube.com/vi/${id}/mqdefault.jpg`,
  },
  {
    name: "Vimeo",
    pattern: /vimeo\.com\/(?:video\/)?(\d+)/,
    embed: (id) => `https://player.vimeo.com/video/${id}`,
    thumbnail: () => null,
  },
  {
    name: "Dailymotion",
    pattern: /(?:dailymotion\.com\/(?:embed\/)?video\/|dai\.ly\/)([a-z0-9]+)/i,
    embed: (id) => `https://www.dailymotion.com/embed/video/${id}`,
    thumbnail: (id) => `https://www.dailymotion.com/thumbnail/video/${id}`,
  },
];

export function parseVideoLink(link) {
  for (const provider of PROVIDERS) {
    const match = String(link || "").match(provider.pattern);
    if (match) {
      return {
        provider: provider.name,
        embedUrl: provider.embed(match[1]),
        thumbnailUrl: provider.thumbnail(match[1]),
      };
    }
  }
  return null;
}
